export default __webpack_public_path__ + "static/media/ridePun.8e10df7b.png";